import gql from 'graphql-tag';

export const GET_VO_PROPOSALS_OPTIONS = gql`
  query VOProposalOptionsList($voId: ID) {
    VOProposalOptionsList: proposals(voId: $voId) {
      value: id
      email
      status
      saleType
      lastName
      firstName
      businessName
      amountRequested
      createdDateTime
    }
  }
`;
